import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useSecurityTier } from '../../contexts/SecurityTierContext';

interface SecurityGateProps {
  requiredTier: 1 | 2 | 3;
  children: React.ReactNode;
}

const TIER_MESSAGES: Record<string, { title: string; description: string; buttonText: string; buttonPath: string }> = {
  'enable-2fa': {
    title: '2FA aktivieren um diese Funktion freizuschalten',
    description:
      'Die Zwei-Faktor-Authentifizierung schützt dein Konto und schaltet erweiterte Funktionen frei.',
    buttonText: '2FA aktivieren',
    buttonPath: '/settings',
  },
  'setup-api-key': {
    title: 'API-Key einrichten um diese Funktion freizuschalten',
    description:
      'Verbinde deinen Btrader-Account um mit echtem Geld zu handeln.',
    buttonText: 'API-Key einrichten',
    buttonPath: '/settings',
  },
};

const SecurityGate: React.FC<SecurityGateProps> = ({ requiredTier, children }) => {
  const { canAccess, nextUpgradeAction } = useSecurityTier();
  const navigate = useNavigate();

  if (canAccess(requiredTier)) {
    return <>{children}</>;
  }

  const message = nextUpgradeAction ? TIER_MESSAGES[nextUpgradeAction] : null;

  // Geschützten Inhalt NICHT rendern — nur Lock-Screen anzeigen
  return (
    <Box sx={{ minHeight: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Paper
          elevation={3}
          sx={{
            p: 4,
            maxWidth: 420,
            textAlign: 'center',
            borderRadius: 3,
          }}
        >
          <LockIcon sx={{ fontSize: 48, color: 'warning.main', mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            {message?.title ?? 'Funktion gesperrt'}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {message?.description ?? 'Weitere Schritte nötig um fortzufahren.'}
          </Typography>
          {message && (
            <Button
              variant="contained"
              onClick={() => navigate(message.buttonPath)}
              sx={{ borderRadius: 2 }}
            >
              {message.buttonText}
            </Button>
          )}
        </Paper>
    </Box>
  );
};

export default SecurityGate;
